import coreAPIInstance from "../core/coreApiInstance";
import magnifiAPIInstance from "./apiInstance";

export const storageAPIs = {
  getAccountStorages: ({ payload }) => magnifiAPIInstance.post(`/storage/get`, payload),
  updateStorageFolder: ({ payload }) => magnifiAPIInstance.post(`/storage-folder-path-update`, payload),
  getAssignedOrganization: ({ payload }) => magnifiAPIInstance.post("storage/assigned-organization", payload),
  getAccountStoragesByEntityId: ({ payload }) => magnifiAPIInstance.post("accounts/storage/get", payload),
  deleteAccountStoragesById: ({ payload }) => magnifiAPIInstance.post("/delete-storage-list", payload),
};

export const coreStorageAPIs = {
  createCoreStorage: ({ payload }) => coreAPIInstance.post("/api/v1/storages", payload),
  updateCoreStorage: ({ payload, id, entityId }) =>
    coreAPIInstance.patch(`/api/v1/storages/${id}`, payload, {
      headers: {
        entityId,
      },
    }),
  deleteCoreStorage: ({ id, entityId }) =>
    coreAPIInstance.delete(`/api/v1/storages/${id}`, {
      headers: {
        entityId,
      },
    }),
  getCoreStorageList: ({ entityId, limit = 100, activePage = 1 }) =>
    coreAPIInstance.get(`/api/v1/storages?entityId=${entityId}&pageSize=${limit}&page=${activePage}`, {
      headers: {
        entityId,
      },
    }),
};
